import { message, Modal } from 'antd'
import Cookies from 'js-cookie'
import { push } from 'react-router-redux'
import { take, put, call, select } from 'redux-saga/effects'
import { handlerCnames } from '@openplatform/utils/index'
import {
  // LOGIN_REQUEST,
  INITIAL_USER_INFO,
  INITIAL_REGISTER_INFO,
  // LOGIN_START,
  LOGIN_SUCCESS,
  // LOGIN_ACCOUNT_OR_PASSWORD_ERROR,
  // LOGIN_TIMEOUT,
  GET_DEVELOPER_INFO_SUCCESS,
  GET_USER_INFO_SUCCESS,
  LOGINOUT,
  LOGINOUT_SUCCESS,
  REFRESH_BROWSER,
  REGISTER_END,
  DOMAINS,
  CHANGE_EXAMINETYPE,
  CHANGE_LOGIN
} from '@openplatform/store/actionTypes/homepage'
import { resetHost, handleConsoleRedirect } from '@openplatform/utils'
import * as adminServices from '@openplatform/request/api/admin'
import * as services from '@openplatform/request/api/login'
import { immutableSelector, setUserInfo } from '@/utils/index'
import { getCookiesDomain } from '@/config/environment'

function getLang() {
  const { getLocaleLanguage } = window as any
  const { lang } = getLocaleLanguage(window.navigator, '')
  const storageLang = localStorage.getItem('curLang')
  return storageLang || lang
}

// 退出登录
function* loginOut() {
  const token = yield select((state) => immutableSelector(state).user.userInfo.apptoken)
  try {
    const lang = localStorage.getItem('curLang')
    yield call(services.loginOut, { login_token: token })
    localStorage.clear()
    // 登出清空 WebIDE cookie 信息
    const d = new Date()
    d.setTime(d.getTime() - 7 * 24 * 60 * 60 * 1000)
    const expires = `expires=${d.toUTCString()}`
    document.cookie = `dev_apptoken=''; domain=.huami.com; path=/;expires=${expires}`
    localStorage.setItem('curLang', lang || 'zh')
    Cookies.set('apptoken', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    Cookies.set('userid', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    Cookies.set('hm-user-login-info', '', {
      expires: -10000000,
      domain: getCookiesDomain()
    })
    yield call(resetHost)
    yield put({ type: LOGINOUT_SUCCESS })
    yield put({ type: CHANGE_EXAMINETYPE, payload: 0 })
  } catch (error) {
    console.log(error)
  }
}

// 查询开发者认证信息
function* getDeveloperInfo() {
  try {
    const authInfo = yield call(adminServices.getAuthInfo)
    if (authInfo?.error?.name === '401') {
      yield call(loginOut)
      Modal.warning({
        title: getLang() === 'zh' ? '登录凭证过期' : 'invalid token',
        okText: getLang() === 'zh' ? '去登录' : 'Login',
        onOk: () => {
          handleConsoleRedirect()
        }
      })
      return
    }
    yield put({ type: GET_DEVELOPER_INFO_SUCCESS, payload: authInfo || {} })
    return authInfo
  } catch (error) {
    console.log(error)
  }
}

// 初始化登录后的用户信息
function* initialUserInfo() {
  try {
    let userInfo: any = Cookies.get('hm-user-login-info')
    if (!userInfo) return
    userInfo = JSON.parse(userInfo)

    const { domains = [] } = userInfo
    yield call(handlerCnames, domains)
    const {
      token_info: { app_token, user_id, login_token },
      regist_info: { country_code },
      thirdparty_info: { email: contact, nickname, third_id }
    } = userInfo
    if (user_id) {
      const { data, status } = yield call(services.getUserInfoFromInterface, user_id, app_token)
      if (status === 401 && data.code === '0102') {
        message.error('login timeout')
        return
      }
      // 获取用户注册信息
      const { userData } = yield call(services.userRegistration, user_id, app_token)
      if (data) {
        userInfo.thirdparty_info.nickname = data.nickName
        if (userData?.country_code) {
          userInfo.regist_info.country_code = userData.country_code
        }
        yield put({ type: GET_USER_INFO_SUCCESS, payload: data })
        yield put({ type: CHANGE_LOGIN, data: true })
        yield call(setUserInfo, {
          userid: user_id,
          apptoken: app_token,
          nickName: data?.nickName || nickname,
          login_token,
          contact,
          country: (userData?.country_code?.toLocaleLowerCase() as string) ?? (country_code?.toLocaleLowerCase() as string),
          iconUrl: data?.iconUrl,
          userIntroduction: data?.userIntroduction
        })
        localStorage.setItem('third_id', third_id)
      }
      yield call(getDeveloperInfo)
      yield put(push(''))
    }
    yield put({ type: LOGIN_SUCCESS, payload: userInfo })
    yield put({ type: DOMAINS, payload: userInfo.domains })
  } catch (error) {
    console.log(error)
  }
}

// 初始化注册后的用户信息
function* initialRegisterInfo() {
  try {
    let regLastRes: any = Cookies.get('hm-user-login-info')
    if (!regLastRes) return
    regLastRes = JSON.parse(regLastRes)

    const {
      token_info: { app_token, user_id, login_token },
      regist_info: { country_code },
      thirdparty_info: { nickname, icon, third_id, email },
      domains,
      domain
    } = regLastRes
    // 域名
    yield call(handlerCnames, domains)
    yield put({ type: DOMAINS, payload: domain })
    // 用户信息
    yield put({
      type: REGISTER_END,
      payload: {
        userid: user_id,
        apptoken: app_token,
        nickName: nickname,
        country: country_code.toLocaleLowerCase(),
        avatar: icon,
        developerID: third_id,
        email
      }
    })
    // 存到localstorage
    yield call(setUserInfo, {
      userid: user_id,
      apptoken: app_token,
      nickName: nickname,
      login_token,
      contact: email,
      iconUrl: '',
      country: country_code.toLocaleLowerCase(),
      userIntroduction: ''
    })
    yield put({
      type: CHANGE_EXAMINETYPE,
      data: 0
    })
    yield put({ type: CHANGE_LOGIN, data: true })
  } catch (error) {
    console.log(error)
  }
}

// 查询用户详细信息
function* getUserDetail({ userid, apptoken }: { userid: string; apptoken: string }) {
  try {
    const userInfo = yield call(services.getUserInfoFromInterface, userid, apptoken)
    console.log(userInfo)
    yield put({ type: GET_USER_INFO_SUCCESS, payload: userInfo?.data })
    return userInfo
  } catch (error) {
    console.log(error)
  }
}

// 统一登录的后续操作
export function* initialUserInfoFlow() {
  while (true) {
    yield take(INITIAL_USER_INFO)
    yield call(initialUserInfo)
  }
}

// 统一注册的后续操作
export function* initialRegisterInfoFlow() {
  while (true) {
    yield take(INITIAL_REGISTER_INFO)
    yield call(initialRegisterInfo)
  }
}

// 退出登录
export function* loginOutFlow() {
  while (true) {
    yield take(LOGINOUT)
    yield call(loginOut)
    yield put(push(''))
  }
}

// 刷新页面流程
export function* refreshFlow() {
  while (true) {
    yield take(REFRESH_BROWSER)
    const apptoken: string | null = localStorage.getItem('apptoken')
    const userid: string | null = localStorage.getItem('userid')
    if (!apptoken || !userid) return
    yield call(resetHost)
    yield call(getDeveloperInfo)
    yield call(getUserDetail, {
      userid,
      apptoken
    })
  }
}
